import { ReactNode } from 'react';
import { BuilderSummary } from './BuilderSummary';

interface BuilderPreviewRowProps {
  builderMode: boolean;
  children: ReactNode;
}

// The chart preview, with the plain-words summary beside it while the builder is in use.
export const BuilderPreviewRow = ({ builderMode, children }: BuilderPreviewRowProps) => (
  <div className={builderMode ? 'row g-3 mb-3' : ''}>
    <div className={builderMode ? 'col-lg-8' : ''}>{children}</div>
    {builderMode && (
      <div className="col-lg-4">
        <BuilderSummary />
      </div>
    )}
  </div>
);
